var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Cartilla',{attrs:{"id_plan":"1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }